import type { TeamMember } from "./content";

type TeamMemberProfileCardProps = {
  member: TeamMember;
};

export const TeamMemberProfileCard = ({ member }: TeamMemberProfileCardProps) => {
  return (
    <div className="flex flex-col items-center gap-5 lg:flex-row lg:items-start">
      <img
        alt="Profile avatar"
        className="size-44 rounded-full bg-surface-muted"
        src={member.avatar}
      />

      <div className="flex flex-col items-center gap-5 lg:items-start lg:gap-3">
        <div className="flex flex-col items-center gap-2 lg:items-start">
          <p className="text-xl font-semibold">{member.name}</p>

          <p className="font-semibold tracking-wider text-content-secondary uppercase">
            {member.title}
          </p>
        </div>

        <p className="text-center leading-6 text-content-secondary sm:text-xl lg:text-left">
          {member.description}
        </p>
      </div>
    </div>
  );
};
